var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTcmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11513_58159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5008 20.5008L16.3038 16.3038M16.3038 16.3038C17.7104 14.8972 18.5006 12.9895 18.5006 11.0003C18.5006 9.01108 17.7104 7.10336 16.3038 5.69678C14.8972 4.29021 12.9895 3.5 11.0003 3.5C9.01108 3.5 7.10336 4.29021 5.69678 5.69678C4.29021 7.10336 3.5 9.01108 3.5 11.0003C3.5 12.9895 4.29021 14.8972 5.69678 16.3038C7.10336 17.7104 9.01108 18.5006 11.0003 18.5006C12.9895 18.5006 14.8972 17.7104 16.3038 16.3038Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02584 11.2049C5.99139 11.1013 5.99139 10.9894 6.02584 10.8859C6.71826 8.80264 8.68369 7.29999 11.0001 7.29999C13.3154 7.29999 15.2799 8.80114 15.9738 10.8834C16.0087 10.9867 16.0087 11.0986 15.9738 11.2024C15.2819 13.2856 13.3164 14.7883 11.0001 14.7883C8.68468 14.7883 6.71975 13.2871 6.02584 11.2049Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.597 10.4982L12.0567 10.0386L11.597 10.4982C11.756 10.6572 11.8453 10.8728 11.8453 11.0976C11.8453 11.3224 11.756 11.5381 11.597 11.697C11.4381 11.856 11.2225 11.9453 10.9977 11.9453C10.7728 11.9453 10.5572 11.856 10.3983 11.697L9.93865 12.1566L10.3983 11.697C10.2393 11.5381 10.15 11.3224 10.15 11.0976C10.15 10.8728 10.2393 10.6572 10.3983 10.4982C10.5572 10.3393 10.7728 10.25 10.9977 10.25C11.2225 10.25 11.4381 10.3393 11.597 10.4982Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11513_58159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcmIcon);
export default __webpack_public_path__ + "static/media/tcm_icon.399a132591e21916ba8091545d3ec9af.svg";
export { ForwardRef as ReactComponent };